export default {
  create_title: 'Nowe konto Partner API',
  edit_title: 'Edytuj konto',
  form: {
    name: 'Nazwa konta',
    name_placeholder: 'np. integracja Acme POS',
    contact_email: 'E-mail kontaktowy',
    scope: 'Dostęp do restauracji',
    companies: 'Restauracje',
    scope_selected: 'Wybrane restauracje',
    scope_all: 'Wszystkie restauracje',
    scope_all_help:
      'Klucze na tym koncie mają dostęp do każdej restauracji Twojej organizacji, w tym zarejestrowanych później.',
    companies_placeholder: 'Wybierz restauracje',
    companies_help: 'Klucze wydane na to konto mogą odczytywać i zapisywać tylko te restauracje.',
    is_active: 'Aktywne',
    is_active_help: 'Nieaktywne konta są odrzucane podczas uwierzytelniania.',
  },
  buttons: {
    cancel: 'Anuluj',
    save: 'Zapisz',
    create: 'Utwórz',
  },
  toasts: {
    created: 'Konto Partner API zostało utworzone.',
    updated: 'Konto zaktualizowane.',
    error: 'Nie udało się zapisać konta.',
  },
};
